import { useRef } from 'react';
import { TYPE_DICTIONARY } from '../../TemplateBuilder/const/templates';
import { useGetDictionariesQuery } from '../../Translations/api/dictionariesApiSlice';
import { DICTIONARY_STATUS } from '../../Translations/pages/Dictionaries/PageDictionaries/PageDictionaries.const';



const useDictionariesOptions = (field) => {
  const timestampRef = useRef(Date.now()).current;

  let options = [];

  if (field?.type !== TYPE_DICTIONARY) {
    return options;
  }

  const { data: { data: dictionaries = [] } = { data: [] },
    isFetching,

  } = useGetDictionariesQuery({
    queryParams: `search=structure_id:${field.value};status:${DICTIONARY_STATUS.READY}&limit=0`,
    sessionId: timestampRef,
  });

  options = dictionaries?.map((dictionary) => {
    return {
      label: dictionary.name,
      value: `${dictionary.id}`,
    };
  });

  return [ options, isFetching ];
};

export default useDictionariesOptions;
